<template>
<div class="home">
  <b-card no-body>
    <b-tabs card>
      <b-tab title="最新報名" active>
        <div class="container">
          <div class="row d-flex align-self-stretch ">
            <template v-for="member in signUpList">
                <Member  :member="member"></Member>
              </template>
          </div>
        </div>
      </b-tab>
      <b-tab title="已報名隊伍列表">
        <MemberList :members="members" :type="1" :order="order"></MemberList>
      </b-tab>
      <b-tab title="尚未報名">
        <MemberList :members="members" :type="2" :order="order"></MemberList>
      </b-tab>
    </b-tabs>
  </b-card>
</div>
</template>

<script>
// @ is an alias to /src
import Firebase from 'firebase'
import notify from 'notifyjs'

import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
import bTab from 'bootstrap-vue/es/components/tabs/tab';
import bCard from 'bootstrap-vue/es/components/card/card';
import Member from '@/components/Member'
import {
  mapGetters,
} from 'vuex'
import MemberList from '@/components/MemberList'

export default {
  name: 'home',
  data: () => ({
    signUpList: [],
    members: {},
    order: {},
    alertedMemberId: [],
    onlyOneAlert: false,
    localAlert: []
  }),
  watch: {
    uid: function() {
      // this.checkUser()
    },
    signUpList: function(n) {
      console.log("signUpList");
      this.checkNeedAlert()
      // this.alertedMemberId = [...diff.map(obj => obj.key)]
    },
    alertedMemberId: function(n) {
      console.log("alertedMemberId");
      // this.checkNeedAlert()
    }
  },
  components: {
    MemberList,
    Member,
    'b-tabs': bTabs,
    'b-tab': bTab,
    'b-card': bCard,
  },
  methods: {
    alert(members) {

      if (this.onlyOneAlert === true ){
        return;
      }
      this.onlyOneAlert = true
      let alertString = ""
      members.forEach(obj => {
        if (this.localAlert.indexOf(obj.key) > -1 ){
          return
        }else{
          this.localAlert.push(obj.key)
        }
        alertString += obj.group + " " + obj.name + " " + obj.team + "\n"
      })
      let self = this
      let doNotification = function() {
        let onNotifyShow = function(){
          console.log("show alert");
        }
        let onclickAction = function(e) {
            window.focus();
            e.currentTarget.close();
        };
        var myNotification = new notify('新增立候補', {
          body: alertString,
          icon: "https://firebasestorage.googleapis.com/v0/b/akb48-53rd.appspot.com/o/akb48.png?alt=media&token=3fab0cae-e0c8-45e9-87d8-6f35b96ee744",
          notifyShow: onNotifyShow,
          notifyClick: onclickAction,
          timeout: 15
        });
        myNotification.show();
        self.onlyOneAlert = false
      }
      if (!notify.needsPermission) {
        doNotification();
      } else if (notify.isSupported()) {
        notify.requestPermission(() => doNotification(), () => {});
      }
      console.log("alertedMemberId push");
      this.alertedMemberId.push(...members.map(obj => obj.key))

      Firebase.firestore().collection("users").doc(this.uid).update({
        alertedMemberId: this.alertedMemberId
      }).then(()=>{console.log("update alertedMemberId success")})

    },
    checkNeedAlert() {
      console.log("checkNeedAlert");
      if (this.alertedMemberId.length == 0) {
        return
      }
      console.log("checkNeedAlert start");

      // let sigupAllkey = this.signUpList.map(obj => obj.key)
      let diff = this.signUpList.filter(obj => this.alertedMemberId.indexOf(obj.key) < 0)
      if (diff.length > 0) {
        this.alert(diff)
      }
    },
    checkUser() {
      if (this.members.length == 0) {
        return
      }
      console.log("checkUser");
      Firebase.firestore().collection("users").doc(this.uid).get().then(doc => {
        if (doc.exists) {
          this.alertedMemberId = doc.data().alertedMemberId
          this.checkNeedAlert()
        } else {
          Firebase.firestore().collection("users").doc(this.uid).set({
            alertedMemberId: this.signUpList.map(obj => obj.key)
          }).then(docRef => {
            this.alertedMemberId = this.signUpList.map(obj => obj.key)
            console.log("success");
          }).catch(error => {
            console.log("error", error);
          })
        }
      })
    },
    initData() {
      Firebase.firestore().collection("config").doc("order").get().then(doc => {
        if (doc.exists) {
          this.order = doc.data()
          // console.log("Document data:", doc.data());
        } else {
          // doc.data() will be undefined in this case
          // console.log("No such document!");
        }
      })


      Firebase.firestore().collection("member").onSnapshot(querySnapshot => {
        let result = {}
        let signUpListArray = []
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            let obj = doc.data()
            obj.key = doc.id
            if (obj.signup == true) {
              signUpListArray.push(obj)
            }

            if (result.hasOwnProperty(obj.group)){
                if (result[obj.group].hasOwnProperty(obj.team)){
                  result[obj.group][obj.team].push(obj)
                }else{
                  result[obj.group][obj.team] = [obj]
                }
            }else{
              result[obj.group] = {[obj.team]: [obj] }

            }
          } else {
            // doc.data() will be undefined in this case
            // console.log("No such document!");
          }
        })

        this.members = result
        this.signUpList = signUpListArray.sort((o1, o2) => {
          if (o1.signupTime > o2.signupTime) {
            return -1
          } else {
            return 1
          }
        })
        if (this.uid && this.alertedMemberId.length == 0) {
          this.checkUser()
        }
      })

    }

  },
  computed: {
    ...mapGetters([
      'uid',
    ])
  },
  mounted() {
    //do something after mounting vue instance
    this.initData()


  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue